import React, { Component } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash';

import { fileType } from 'types';
import Dropdown from 'components/Dropdown';
import DropdownItem from 'components/DropdownItem';

import './style.scss';

export default class DropDownMenu extends Component {
  static propTypes = {
    deleteAll: PropTypes.func.isRequired,
    exportAll: PropTypes.func.isRequired,
    addNewFile: PropTypes.func,
    items: PropTypes.arrayOf(fileType),
  };

  handleClick = () => {
    // eslint-disable-next-line react/destructuring-assignment
    const addNewFile = this.props.addNewFile || noop;
    addNewFile();
    this.dropdown.hide();
  };

  handleExportAll = () => {
    this.props.exportAll();
    this.dropdown.hide();
  };

  handleDeleteAll = () => {
    this.props.deleteAll(this.props.items);
    this.dropdown.hide();
  };

  renderDropdownExtraItems = () => {
    if (!this.props.items.length) {
      return null;
    }

    return (
      <React.Fragment>
        <DropdownItem
          className="item"
          data-test="export"
          onClick={this.handleExportAll}
        >
          Export all
        </DropdownItem>
        <hr />
        <DropdownItem
          className="item"
          data-test="delete"
          onClick={this.handleDeleteAll}
        >
          Delete All
        </DropdownItem>
      </React.Fragment>
    );
  };

  /* eslint-disable react/destructuring-assignment */
  render() {
    return (
      <Dropdown
        data-test="dropdown-content"
        inputRef={el => {
          this.dropdown = el;
        }}
        styleName="dropdown"
        trigger={
          <span
            data-tip
            className="icon-options"
            data-event="mouseover"
            data-for="upload-appconfig-files"
            data-test="icon-options"
            styleName="trigger"
          />
        }
      >
        {Boolean(this.props.addNewFile) && (
          <DropdownItem
            className="item"
            data-test="create"
            onClick={this.handleClick}
          >
            Create
          </DropdownItem>
        )}
        {this.renderDropdownExtraItems()}
      </Dropdown>
    );
  }
}
